import { render, staticRenderFns } from "./ResourcesMngtDtl.vue?vue&type=template&id=421c6d0c&scoped=true"
import script from "./ResourcesMngtDtl.vue?vue&type=script&lang=js"
export * from "./ResourcesMngtDtl.vue?vue&type=script&lang=js"
import style0 from "./ResourcesMngtDtl.vue?vue&type=style&index=0&id=421c6d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c6d0c",
  null
  
)

export default component.exports